import { render } from "./ModalUploadPdfNotaSpesa.vue?vue&type=template&id=67519554&scoped=true"
import script from "./ModalUploadPdfNotaSpesa.vue?vue&type=script&lang=js"
export * from "./ModalUploadPdfNotaSpesa.vue?vue&type=script&lang=js"

import "./ModalUploadPdfNotaSpesa.vue?vue&type=style&index=0&id=67519554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67519554"]])

export default __exports__